var els = $('table[data-saved-searches]');
if (els.length > 0) {
  require.ensure('../controllers/saved_searches_controller', function(require) {
    var SavedSearchesController = require('../controllers/saved_searches_controller');
    els.each(function() {
      return new SavedSearchesController(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/saved_searches.initializer.js